// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ae103657","663":"9fb00a63","977":"196f5fa2"}[chunkId] + ".chunk.js";
};